
            const data = {"name":"x","data":{"width":"16","height":"17","viewBox":"0 0 16 17","data":"<path pid=\"0\" d=\"M14.59 1.91a1.398 1.398 0 00-1.977 0L8.01 6.513 3.404 1.909a1.398 1.398 0 00-1.977 1.978L6.032 8.49l-4.605 4.605a1.398 1.398 0 101.977 1.977L8.01 10.47l4.604 4.604a1.398 1.398 0 001.978-1.977L9.986 8.49l4.605-4.604a1.398 1.398 0 000-1.978z\" _fill=\"currentColor\" opacity=\".7\"/>"}}
        
                module.exports = data
                